import React from 'react';
import womanOne from '../assets/images/profile1.png';
import womanTwo from '../assets/images/dp_3.png';
import womanThree from '../assets/images/user1.png';
import manOne from '../assets/images/dp_1.png';
import manTwo from '../assets/images/dp_2.png';
import manThree from '../assets/images/local_man_3.png';

interface LocalSinglesProps {
  city: string;
  womenText: string;
  menText: string;
  womenHeading?: string;
  menHeading?: string;
}

const WOMEN = [womanOne, womanTwo, womanThree];
const MEN = [manOne, manTwo, manThree];

const Avatars: React.FC<{ images: string[]; label: string }> = ({ images, label }) => (
  <div className="local_singles_avatars">
    {images.map((src, i) => (
      <img key={src} src={src} alt={`${label} ${i + 1}`} loading="lazy" />
    ))}
  </div>
);

// Two separate sections shown on every location page: single women and single men,
// each with a heading, a row of profile photos and a short description.
const LocalSingles: React.FC<LocalSinglesProps> = ({ city, womenText, menText, womenHeading, menHeading }) => (
  <>
    <section className="py-100 our_values_section local_singles_section">
      <div className="container">
        <h2 className="local_singles_heading mb-4">{womenHeading || `Single Ladies in ${city} Near You`}</h2>
        <Avatars images={WOMEN} label={`Single women in ${city}`} />
        <p className="mb-0 font20">{womenText}</p>
      </div>
    </section>

    <section className="py-100 our_values_section bg-light local_singles_section">
      <div className="container">
        <h2 className="local_singles_heading mb-4">{menHeading || `Single Men in ${city}`}</h2>
        <Avatars images={MEN} label={`Single men in ${city}`} />
        <p className="mb-0 font20">{menText}</p>
      </div>
    </section>
  </>
);

export default LocalSingles;
